// import { Affix, Button, Card } from "antd";
// import { useCallback, useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
// import { isArrayAndHasValue } from "utils/functions";
// import { getData } from "../../../apiServices/common";
// import { isMobileView } from "../../Common/AppHelper";
// import Header from "../../Common/Header";
// import AddFoldingRequirementForm from "./AddFoldingRequirementForm";

// export default function UpdateFoldingRequirement(props) {
//   // Props
//   const { width } = props;

//   // States
//   const [permitInfo, setPermitInfo] = useState();
//   const [poDetailsData, setPoDetailsData] = useState(null);

//   // Others
//   const { itemId } = useParams();
//   const propertyFormRef = useRef(null);

//   const addProduct = () => {
//     propertyFormRef.current.submit();
//   };

//   const getPOInfo = useCallback(async () => {
//     const query = `/api/unit_prices/${itemId}/edit`;
//     const response = await getData(query);

//     if (response && response?.data?.code === 200) {
//       const masterData = response.data.data;
//       setPermitInfo(masterData);
//       const po_data = masterData ? masterData.unit_price_details : null;

//       const po_details =
//         isArrayAndHasValue(po_data) &&
//         po_data.map((item) => {
//           const sizes = {};

//           item?.sizes.forEach((size) => {
//             sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
//           });
//           return {
//             ...item,
//             style_id: item.style.id,
//             color_id: item.color.id,
//             ...sizes,
//           };
//         });

//       setPoDetailsData(po_details || []);
//     }
//   }, [itemId]);

//   useEffect(() => {
//     // Only run on first render
//     // DO NOT add any depenedency here
//     getPOInfo();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <>
//       <Affix offsetTop={0}>
//         <Card
//           className="p-fixed"
//           style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
//         >
//           <Header
//             title={"Update Folding Requirement"}
//             subTitle=""
//             addLink="/"
//             addText="Add New"
//             actions={[
//               <Button
//                 size="small"
//                 key={2}
//                 type="primary"
//                 onClick={() => addProduct()}
//               >
//                 Update
//               </Button>,
//             ]}
//           />
//         </Card>
//       </Affix>

//       <AddFoldingRequirementForm
//         ref={propertyFormRef}
//         permitInfo={permitInfo}
//         poDetailsData={poDetailsData}
//         setPoDetailsData={setPoDetailsData}
//         mode="update"
//       />
//     </>
//   );
// }

import { Affix, Button, Card } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddPurchaseOrderForm from "./AddFoldingRequirementForm";
import { FOLDING_REQUIREMENT_VIEW } from "apiServices/API_ENDPOINTS";
import AddFoldingRequirementForm from "./AddFoldingRequirementForm";

export default function UpdateFoldingRequirement(props) {
  // Props
  const { width } = props;

  // Router
  let { id } = useParams();
  const navigate = useNavigate();

  // States
  const [info, setInfo] = useState();
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [initialPolyData, setInitialPolyData] = useState([]);

  // Others
  const propertyFormRef = useRef(null);
  const edit_url = `${FOLDING_REQUIREMENT_VIEW}/${id}`;

  const discartForm = () => {
    navigate("/digitalization/folding-requirement");
  };

  const getPOInfo = useCallback(async () => {
    let res = await getData(edit_url);

    if (res) {
      let masterData = res.data.data;
      setInfo(masterData);

      // Prepare selectedSizes from poly_size_ratios
      let sizes = [];
      if (
        Array.isArray(masterData.folding_requirement_polys) &&
        masterData.folding_requirement_polys.length > 0
      ) {
        const allSizes = masterData.folding_requirement_polys.flatMap((poly) =>
          poly.poly_size_ratios.map((sr) => sr.size_info),
        );
        // Remove duplicates by id
        const uniqueSizes = [];
        const seen = new Set();
        allSizes.forEach((size) => {
          if (!seen.has(size.id)) {
            seen.add(size.id);
            uniqueSizes.push({ id: size.id, name: size.name });
          }
        });
        sizes = uniqueSizes;
      }
      setSelectedSizes(sizes);

      // Prepare initialPolyData for DetailsTable
      const polys = (masterData.folding_requirement_polys || []).map((poly) => {
        const row = {
          key: poly.id,
          polyNo: poly.ratio_name,
        };
        (poly.poly_size_ratios || []).forEach((sr) => {
          row[`size_${sr.size_id}`] = sr.quantity;
        });
        return row;
      });
      setInitialPolyData(polys);
    }
  }, [edit_url]);

  useEffect(() => {
    getPOInfo();
  }, [getPOInfo]);

  const addPurchaseOrder = () => {
    propertyFormRef.current.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Update Folding Requirement"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Back
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addPurchaseOrder()}
              >
                Update Folding Requirement
              </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <AddFoldingRequirementForm
        ref={propertyFormRef}
        info={info}
        view={false}
        mode={"edit"}
        selectedSizes={selectedSizes}
        initialPolyData={initialPolyData}
      />
    </>
  );
}
